import { useQuery } from "@tanstack/react-query";

import { Response } from "../types";

import { InputVariableSet } from "./types";

import { authHeader } from "@/utils/headers";
import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";

export const useGetInputVariableSet = (
  workspaceId: number,
  inputVariableSetId: number,
  userToken: string,
  enabled = true,
) =>
  useQuery<Response<InputVariableSet, "input_variable_set", string>>({
    queryKey: ["input-variable-sets", workspaceId, inputVariableSetId],
    queryFn: async ({ signal }) => {
      const response = await fetch(ENDPOINTS.input_variable_sets(workspaceId, inputVariableSetId), {
        headers: authHeader(userToken),
        signal,
      });

      return handleResponse(response);
    },
    enabled: enabled && !!workspaceId && !!inputVariableSetId,
  });
